import { IssueSearchFilteringDtoOptions } from '@issuemanager/api-client';

export function isSourceEntityFilterPresent(
  filter: IssueSearchFilteringDtoOptions,
): boolean {
  return (
    Array.isArray(filter.sourceEntityFilter) &&
    filter.sourceEntityFilter.length > 0
  );
}
